import React from 'react';
import './Logo.scss';

interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <div className="logo-container">
      <img 
        className={`logo-img ${className}`}
        src={`${process.env.PUBLIC_URL}/mp_logo_01.png`} 
        alt="Logo Medio Punto"
      />
    </div>
  );
};

export default Logo;